import Bellefont1 from './Bellefont.webp'
import Bellefont2 from './Bellefont 8 (2).webp'
import Bellefont3 from './Bellefont 10 (2).webp'
import Bellefont4 from './Bellefont 12 (2).webp'

const Bellefontimages =[
Bellefont1,Bellefont2,Bellefont3,Bellefont4
]

export default Bellefontimages;